import { useHome } from './hooks/useHome';
import { useTranslation } from "react-i18next";

import 'swiper/css';
import 'swiper/css/free-mode';

// import productos from '../../core/data/productos.json'
import { PorqueElegirnosComponent } from './components/PorqueElegirnosComponent';
import { Link } from 'react-router-dom';
import { NuestrosClientesComponents } from './components/NuestrosClientesComponent';
import MapaComponent from './components/MapaComponent';
import { useEffect, useState } from 'react';

import WOW from 'wowjs';

export const HomePage = () => {

    const { t, i18n } = useTranslation();

    const [products, setProducts] = useState([]);

    const { functions } = useHome();

    useEffect(() => {
        import(`../../core/data/${i18n.language}Productos.json`)
            .then((module) => setProducts(module.default))
            .catch((err) => console.error("Error loading products", err));
    }, [i18n.language]);

    useEffect(() => {
        new WOW.WOW().init();
    }, [products]);

    return (
        <>
            <section id="inico" className="slider-area section-inicio">
                <div id='owl-demo' className="main-slider owl-theme owl-carousel">
                    <div className="single-slide item" style={{
                        backgroundImage: "url(assets/img/slider/banner1.png)"
                    }}>
                        <div className="slider-content-area">
                            <div className="row">
                                <div className="slide-content-wrapper text-center">
                                    <div className="slide-content-wrapper text-center">
                                        <div className="slide-content">
                                            <img className="classic" src="assets/img/logo.png" />
                                            <h2>{t("bannerTitle")}</h2>
                                            <p>{t("bannerDescription")}</p>

                                            <Link
                                                to={'/productos'}
                                                className={`default-btn`}>
                                                {t("bannerButtonText")}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="single-slide item" style={{
                        backgroundImage: "url(assets/img/slider/banner2.png)"
                    }}>
                        <div className="slider-content-area">
                            <div className="row">
                                <div className="slide-content-wrapper text-center">
                                    <div className="slide-content-wrapper text-center">
                                        <div className="slide-content">
                                            <img className="classic" src="assets/img/logo.png" />
                                            <h2>{t("bannerTitle")}</h2>
                                            <p>{t("bannerDescription")}</p>

                                            <Link
                                                to={'/productos'}
                                                className={`default-btn`}>
                                                {t("bannerButtonText")}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="single-slide item" style={{
                        backgroundImage: "url(assets/img/slider/banner3.png)"
                    }}>
                        <div className="slider-content-area">
                            <div className="row">
                                <div className="slide-content-wrapper text-center">
                                    <div className="slide-content-wrapper text-center">
                                        <div className="slide-content">
                                            <img className="classic" src="assets/img/logo.png" />
                                            <h2>{t("bannerTitle")}</h2>
                                            <p>{t("bannerDescription")}</p>

                                            <Link
                                                to={'/productos'}
                                                className={`default-btn`}>
                                                {t("bannerButtonText")}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <section id="eleccion" className='section-eleccion mt-5'>
                <PorqueElegirnosComponent t={t} />
            </section>
            {/* <section id="categorias" className='section mt-5'>
                <div className="background-overlay">
                    <img src='assets/img/new/foods.png' />
                </div>
                <div className='d-flex flex-column align-items-center mb-5'>
                    <h1 className='title-section mb-4'>Categorias destacadas</h1>
                </div>
                <Swiper
                    slidesPerView={3}
                    spaceBetween={10}
                    className="mySwiper col-12 col-sm-12 col-md-9 col-lg-6"
                >
                    <SwiperSlide>
                        <div className='card-categorie shadow-default' style={{ backgroundColor: "#edae00" }}>
                            <div className='image-categorie-card'>
                                <img className="" src={`assets/img/sections/vegetales.png`} />
                            </div>
                            <h1 className='title-categorie'>Vegetales</h1>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='card-categorie shadow-default' style={{ backgroundColor: "#6C3B2A" }}>
                            <div className='image-categorie-card'>
                                <img className="" src={`assets/img/sections/hortalizas.png`} />
                            </div>
                            <h1 className='title-categorie'>Hortalizas</h1>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='card-categorie shadow-default' style={{ backgroundColor: "#0f3d0e" }}>
                            <div className='image-categorie-card'>
                                <img className="" src={`assets/img/sections/frutas.png`} />
                            </div>
                            <h1 className='title-categorie'>Frutas</h1>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </section> */}
            <section id="products" className='section mt-5'>
                <div className='d-flex flex-column align-items-center mb-5 wow bounce'>
                    <h1 className='title-section mb-4'>{t("freshProducts")}</h1>
                </div>

                <div className='container p-0'>
                    <div className="row row-cols-1 row-cols-md-3 row-cols-sm-2 row-cols-lg-4 p-0">
                        {
                            functions.shuffle(Array.from(products)).slice(0, 8).map((item, index) => {
                                return (
                                    <div className="col d-flex justify-content-center mb-5 wow flipInX" key={index}>
                                        <div className='card-product shadow-default py-3'>
                                            <div className='image-product-card'>
                                                <img className="" src={`assets/img/products/${item.imagen}`} />
                                            </div>
                                            <div className='card-product-body'>

                                                <div className="card-product-info">
                                                    <p className='sub-title-product mx-3 mt-0'>{item.categoria}</p>
                                                    <h1 className='title-product mx-3'>{item.nombre}</h1>
                                                </div>

                                                <div className='card-product-footer d-flex justify-content-center mx-3 mt-4'>
                                                    {/* <p className='' style={{ color: "#b2b2b2ff" }}>{item.unidadMedida}</p> */}
                                                    {/* <label className='badge-product'>Ver producto</label> */}
                                                    <Link
                                                        to={`/productos/${item.slug}`}
                                                        className={`default-btn`}>
                                                        {t("seeProducts")}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='text-center mt-4'>
                        <Link
                            to={'/productos'}
                            className={`btn btn-lg bg-primary text-center px-4`}>
                            {t("seeAllProducts")}
                        </Link>
                    </div>
                </div>
            </section>
            <section id="logistica" className='section mt-5'>
                <div className="hero shadow-default wow swing">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-5">
                                <div className="intro-excerpt">
                                    <h1>{t("logisticsTransportation")}</h1>
                                    <p className="mb-4">{t("logisticsDescription")}</p>
                                    <p>
                                        • {t("logisticsItem1")} <br />
                                        • {t("logisticsItem2")} <br />
                                        • {t("logisticsItem3")} <br />
                                        • {t("logisticsItem4")}
                                    </p>
                                    <br />
                                    <br />
                                    <div className='w-100'>
                                        <a href="https://wa.me/+573150459980?text=Hola, quiero cotizar" target="_blank" className="btn w-100 btn-secondary me-2" style={{
                                            background: "#fff",
                                            color: "#0f3d0e",
                                            fontWeight: "500",
                                            fontSize: "1.3rem"
                                        }}>{t("quote")}</a>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="hero-img-wrap">
                                    <img src="assets/img/sections/turbo.png" className="img-fluid " />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <section className='section px-0 mt-5' style={{ background: "#0f3d0e" }}>
                {/* <div className="background-overlay">
                    <img src='assets/img/new/col.png' />
                </div> */}
                <div className='container wow fadeInUp'>
                    <div className='d-flex flex-column align-items-center mt-4'>
                        <h1 style={{ fontSize: "3rem", textTransform: "uppercase" }} className='text-white'>{t("distributionTo")} <span className='fw-bold' style={{ color: "#edae00" }}>{t("nationalLevel")}</span></h1>
                    </div>
                    <MapaComponent />
                </div>
            </section>
            <section id='clientes' className='section px-0 mt-5' >
                <div className='d-flex flex-column align-items-center'>
                    <h1 className='title-section mb-4'>{t("customerNetwork")}</h1>
                </div>
                <NuestrosClientesComponents />
            </section>
            <br />
        </>
    );
}